export const INIT_FORM = {
    studentPenalizedId: 0,
    reasonForPenalizeId: 0,
    details: "",
    penalizeDays: ""
};

export const STYLE_PROPS_CUSTOM_SELECT = {
    minWidth: "180px",
    width: {
        container: "unset",
        containerSelect: "100%"
    }
};

export const EDIT_PENALIZE_DIALOG_FORM_PROPS = {
    title: "¿Deseas editar la sanción del alumno?",
    subtitle: "Recuerda que al editar la sanción, la sanción se actualizará automáticamente.",
    confirm: "Sí, editar"
};

export const CREATE_PENALIZE_DIALOG_FORM_PROPS = {
    title: "¿Deseas sancionar al alumno?",
    subtitle: "Recuerda que para sancionar a un alumno, debes completar los siguientes campos.",
    confirm: "Sí, sancionar"
};

export const PENALTY_DETAILS_MAX_LENGTH = 400;